import React, { useState } from "react";
import { Box, Typography, Switch, FormControlLabel, Button, Card, Avatar, Divider, } from "@mui/material";


const Settings = () => {
    const [darkMode, setDarkMode] = useState(false);

    return (
        <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
            <Card sx={{ p: 4, width: "100%", maxWidth: 600, boxShadow: 4, borderRadius: 3 }}>

                {/* User Profile Section */}
                <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                    <Avatar sx={{ width: 56, height: 56, mr: 2 }}>JD</Avatar>
                    <Box>
                        <Typography variant="h6">John Doe</Typography>
                        <Typography variant="body2" color="text.secondary">john@example.com</Typography>
                    </Box>
                </Box>

                <Divider sx={{ mb: 3 }} />

                {/* Appearance Settings */}
                <Typography variant="h6" gutterBottom>
                    Appearance
                </Typography>
                <FormControlLabel
                    control={
                        <Switch
                            checked={darkMode}
                            onChange={() => setDarkMode(prev => !prev)}
                        />
                    }
                    label="Dark Mode" />

                {/* Language Settings */}
                <Box mt={3}>
                    <Typography variant="h6" gutterBottom>
                        Language
                    </Typography>
                </Box>

                {/* Save Button */}
                <Box mt={4}>
                    <Button variant="contained" color="primary" fullWidth>
                        OK
                    </Button>
                </Box>
            </Card>
        </Box>
    );
};

export default Settings;
